import React, { useState } from 'react';
import Form from '../../coreComponents/Form/Form.tsx';
import { useNavigate } from 'react-router-dom';
import { TestUser } from './types.ts';
import { createTestNumber } from '../../services/CommonService.ts';

const CreateDriver: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const initialValues: TestUser = {
    hardcoded_otp: '',
    phone_number: '',
  };

  const handleSubmit = async (data: TestUser) => {
    const payload = { ...data, phone_number: `+91${data.phone_number}` };
    try {
      const response = await createTestNumber(payload);
      if (response.data) {
        console.log(response.data);
        navigate('/test-numbers');
      }
    } catch (err: any) {
      if (err.response && err.response.status === 401) {
        console.error('Unauthorized access. Redirecting to login...');
        navigate('/login');
      } else {
        setError('Failed to create test number');
        console.log(err);
      }
    }
  };

  const handleCancel = () => {
    navigate('/test-numbers');
  };

  const fields = [
    { type: 'text', name: 'hardcoded_otp', label: 'OTP', required: true },
    {
      type: 'text',
      name: 'phone_number',
      label: 'Phone Number',
      required: true,
    },
  ];

  const buttons = [
    {
      id: 'submit-button',
      children: 'Submit',
      type: 'submit' as 'submit',
      variant: 'contained' as 'contained',
      fullWidth: false,
    },
    {
      id: 'cancel-button',
      children: 'Cancel',
      type: 'button' as 'button',
      variant: 'contained' as 'contained',
      fullWidth: false,
    },
  ];

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="scrollable-form">
      <h1>Create Test User</h1>
      <Form
        fields={fields}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        buttons={buttons}
      />
    </div>
  );
};

export default CreateDriver;
